/**
 * @deprecated
 */
export class System {
    constructor(coreApi) {
        this.coreApi = coreApi;
    }
}
export class PlannerComponentListener {
    constructor(owner, componentId) {
        this.ownerSystem = owner;
        this.componentId = componentId;
    }
    onAdd(entity, newComponent) {
        this.ownerSystem.onAdd(entity, newComponent);
    }
    onUpdate(entity, oldComponent, newComponent) {
        this.ownerSystem.onUpdate(entity, oldComponent, newComponent);
    }
    onRemove(entity, oldComponent) {
        this.ownerSystem.onRemove(entity, oldComponent);
    }
}
export class PlannerEcsSystem {
    constructor(coreApi, id, componentId) {
        this.systemsBeforeMe = null;
        this.systemsAfterMe = null;
        this.doingChangesOnComponent = [];
        this.ignoreEntitiesWithComponents = null;
        this.mandatoryComponents = null;
        this.id = id;
        this.coreApi = coreApi;
        this.isEnabled = true;
        this.componentId = componentId;
        this.componentListeners =
            componentId !== null ? [new PlannerComponentListener(this, componentId)] : [];
    }
    onRegister() { }
    onUnregister() { }
    /**
     * Enable system
     */
    enable() {
        this.isEnabled = true;
    }
    /**
     * Disable system
     */
    disable() {
        this.isEnabled = false;
    }
}
export const initSystemsWithMarketProducts = (productsInMarket, coreApi) => {
    const systemsWithMarketProducts = coreApi
        .getServices()
        .entityManager.getSystemsRegistered()
        .filter(system => 'setMarketProducts' in system);
    systemsWithMarketProducts.forEach((system) => system.setMarketProducts(productsInMarket));
};
/**
 * This class is used to register a system that listens to
 * multiple components. For each component it will register a subsystem
 * that triggers onAdd, onUpdate and onRemove for that specific component.
 *
 * Classes that extend this class needs to check which component triggered the
 * change in onAdd, onUpdate and onRemove functions.
 */
export class PlannerEcsMultiSystem extends PlannerEcsSystem {
    constructor(coreApi, id, componentIds) {
        super(coreApi, id, null);
        this.onAdd = this.onAdd.bind(this);
        this.onUpdate = this.onUpdate.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.componentListeners = componentIds.map(componentId => new PlannerComponentListener(this, componentId));
    }
}
//# sourceMappingURL=System.js.map